<template>
    <rkm-overlay>
        <rkm-layout-body title="Jornada - Lista de veículos">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import List from '@/components/transporte-paciente/jornada/List'

export default {
    components: { List },
}
</script>